import { useEffect, useState } from "react";
import "./inlineTypeAhead.scss";

export interface InlineTypeAheadProps {
    options: string[];
    alwaysShowOptions: boolean;
    setValue: (text: string) => void;
}

interface TypeAheadUserState {
    inputText: string;
    suggestedOptions: string[];
}

export const InlineTypeAhead = ({ options, alwaysShowOptions, setValue }: InlineTypeAheadProps) => {
    const [state, setState] = useState<TypeAheadUserState>({
        inputText: '',
        suggestedOptions: []
    });

    useEffect(() => {
        if (alwaysShowOptions) {
            setState({ ...state, suggestedOptions: options });
        }
    }, []);

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        let suggestions: string[] = [];
        const value = e.target.value;
        setState({ ...state, inputText: value });
        if (value.length > 0) {
            // const regex = new RegExp(`^${value}`, `i`);
            // suggestions = options.sort().filter(v => regex.test(v));
            suggestions = options.sort().filter(x => x.includes(value));
        } else {
            suggestions = options;
        }

        setState({
            inputText: value, suggestedOptions: suggestions
        });
    }

    function suggestionSelected(val: string) {
        setState({ inputText: val, suggestedOptions: state.suggestedOptions });
        setValue(val);
    }

    function renderOptions() {
        const searchOptions = state.suggestedOptions;
        if (searchOptions.length === 0 && state.inputText.length > 0) {
            return null;
        }
        return (
            <ul className="type-ahead-list" data-testid="type-ahead-list">
                {searchOptions.map(opt => <li key={opt} onClick={() => suggestionSelected(opt)}>{opt}</li>)}
            </ul>
        );
    }

    return (
        <div className="inline-typeahead-dropdown" data-testid="inline-typeahead">
            <input className="inline-typeahead-input"
                type="text"
                name="job_owner"
                placeholder="Search by email"
                id="owner"
                autoComplete="off"
                value={state.inputText}
                onChange={handleInputChange}
            />
            {state.suggestedOptions.length > 0 ?
                <div className="users-dropdown-content">
                    {renderOptions()}
                </div>
                : null
            }
        </div>
    );
};